<template>
  <UserForm action="create" />
</template>

<script>
import UserForm from '@/components/User/UserForm'

export default {
  components: {
    UserForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/Create.vue